import React, { useMemo } from 'react';
import { useHMSTheme } from "@100mslive/hms-video-react";
import { hmsUiClassParserGenerator } from '../../common/utils';

const defaultClasses = {
  root:
    'placeholder-gray-400 relative bg-gray-600 dark:bg-gray-200 text-gray-100 dark:text-white text-lg rounded-lg border-0 outline-none focus:outline-none focus:ring w-full',
  rootCompact: `py-2 px-3`,
  rootNonCompact: `p-3`,
  rootRing: `ring-blue-300`,
  rootValidationRing: `ring-red-main`,
  rootValidationText: `text-red-main mt-2`,
};

export const Input = React.forwardRef(
  (
    {
      compact,
      validation,
      placeHolder,
      classes,
      children,
      ...props
    },
    ref,
  ) => {
    const { tw } = useHMSTheme();
    const styler = useMemo(
      () =>
        hmsUiClassParserGenerator({
          tw,
          classes,
          defaultClasses,
          tag: 'hmsui-input',
        }),
      [tw, classes],
    );

    return (
      <>
        <input
          ref={ref}
          placeholder={placeHolder}
          className={`${styler('root')} ${
            compact ? styler('rootCompact') : styler('rootNonCompact')
          } ${validation ? styler('rootValidationRing') : styler('rootRing')}`}
          {...props}
        >
          {children}
        </input>
        {validation && (
          <p className={`${styler('rootValidationText')}`}>{validation}</p>
        )}
      </>
    );
  },
);
